export const DOUBLE_ENTRY_ITEM_HEADER = [
    {
        "label": "No",
        "value": "no",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Item Name",
        "value": "description_as_per_bill",
        "defaultChecked": true,
        "checked": true
        // Date of Invoice/Voucher Invoice Date/ voucher_invoice_date
    },

    {
        "label": "HSN/SAC",
        "value": "hsn_sac_code",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Quantity",
        "value": "quantity",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Unit",
        "value": "unit",
        "defaultChecked": true,
        "checked": true
    },

    {
        "label": "Total Value",
        "value": "total_value",
        "defaultChecked": true,
        "checked": true
    }
]
export const GEN_PDF_HEADER = [
    {
        "label": "No",
        "value": "no",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Item Name",
        "value": "description_as_per_bill",
        "defaultChecked": true,
        "checked": true
        // Date of Invoice/Voucher Invoice Date/ voucher_invoice_date
    },

    {
        "label": "HSN/SAC",
        "value": "hsn_sac_code",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "IGST",
        "value": "igst_amount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "SGST",
        "value": "sgst_amount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "CGST",
        "value": "cgst_amount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "GST %",
        "value": "gst_percentage",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Quantity",
        "value": "quantity",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Unit",
        "value": "unit",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Rate",
        "value": "rate",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Taxable Value",
        "value": "taxable_value",
        "defaultChecked": true,
        "checked": true
    },

    {
        "label": "Total Value",
        "value": "total_value",
        "defaultChecked": true,
        "checked": true
    }
]